import React from "react";
import { formPanelSectionStyles } from "./formPanelSection.styles";

interface FormPanelSectionProps {
  title: string;
  iconClassName?: string;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

export const FormPanelSection = (props: FormPanelSectionProps) => (
  <section
    className={props.className}
    style={{ ...formPanelSectionStyles.panel, ...props.style }}
  >
    <div style={formPanelSectionStyles.header}>
      {props.iconClassName && <i className={props.iconClassName} />}
      <span>{props.title}</span>
    </div>
    {props.children}
  </section>
);
